import { PageFilter } from './types';
import { assembleURL, isPageNavigationFilter, isRegularFilter } from './utils';

export class Filter {
    private selectedFilters: PageFilter[];
    private appliedFilters: number;

    constructor() {
        this.selectedFilters = [];
        this.appliedFilters = 0;
    }

    // Note: in case of page navigation, we have to pass the 'link' value e.g. /trending_videos/
    addFilter(filter: PageFilter) {
        const existingFilter = this.selectedFilters.find((object) => this.isSameFilter(filter, object));

        if (existingFilter) {
            this.removeFilter(existingFilter);
        }
        if (filter.value && filter.value !== '0') {
            this.selectedFilters.push(filter);
        }
        this.updateNumberOfAppliedFilters();
    }

    removeFilter(existingFilter: PageFilter) {
        const index = this.selectedFilters.findIndex((object) => this.isSameFilter(existingFilter, object));
        if (index !== -1) {
            this.selectedFilters.splice(index, 1);
            this.updateNumberOfAppliedFilters();
        }
    }

    isSameFilter(filter1: PageFilter, filter2: PageFilter) {
        return (
            (isRegularFilter(filter1) && isRegularFilter(filter2) && filter1.query === filter2.query) ||
            (isPageNavigationFilter(filter1) && isPageNavigationFilter(filter2))
        );
    }

    updateNumberOfAppliedFilters() {
        this.appliedFilters = this.selectedFilters.filter((object) => !isPageNavigationFilter(object)).length;
    }

    getSelectedFilters() {
        return this.selectedFilters;
    }

    getAppliedFilters() {
        return this.appliedFilters;
    }

    applyFilters() {
        const url = assembleURL(this.selectedFilters);
        window.location.href = url.toString();
    }

    clearFilters() {
        this.selectedFilters = this.selectedFilters.filter((object) => object.isPageNavigation);
        this.appliedFilters = 0;
    }
}
